import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20composition%20of%20fashion%20items%20white%20sneakers%20beige%20sweater%20sunglasses%20and%20small%20accessories%20arranged%20in%20circular%20pattern%20on%20cream%20paper%20background%20soft%20overhead%20daylight%20editorial%20product%20photography%20clean%20Scandinavian%20minimalist%20aesthetic%20warm%20natural%20tones&width=1600&height=900&seq=hero-main-bg&orientation=landscape"
          alt="Curated Pandabuy fashion products flatlay"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 h-full flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-16 max-w-7xl mx-auto">
            <div className="flex-1 flex flex-col gap-6 pt-8 md:pt-0">
              <div className="flex items-center gap-2">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-white/60 overflow-hidden bg-white/10">
                  <img
                    src="https://readdy.ai/api/search-image?query=Extreme%20closeup%20of%20white%20leather%20sneaker%20toe%20box%20with%20perforation%20details%20and%20cream%20stitching%20on%20white%20background%20soft%20natural%20light%20product%20texture%20photography%20minimalist%20clean%20aesthetic&width=100&height=100&seq=hero-thumbnail-1&orientation=squarish"
                    alt="Sneaker leather detail closeup"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-white/60 overflow-hidden bg-white/10 -ml-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Closeup%20of%20soft%20knit%20sweater%20fabric%20texture%20in%20warm%20oatmeal%20color%20with%20visible%20weave%20pattern%20on%20cream%20background%20soft%20lighting%20tactile%20product%20photography%20minimalist%20elegant%20style&width=100&height=100&seq=hero-thumbnail-2&orientation=squarish"
                    alt="Knit sweater fabric closeup"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-white/60 overflow-hidden bg-white/10 -ml-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Closeup%20of%20gold%20toned%20watch%20face%20with%20minimalist%20dial%20design%20and%20leather%20strap%20on%20soft%20cream%20background%20natural%20light%20reflecting%20off%20glass%20luxury%20accessory%20photography%20clean%20sophisticated%20aesthetic&width=100&height=100&seq=hero-thumbnail-3&orientation=squarish"
                    alt="Gold watch detail closeup"
                    className="w-full h-full object-cover"
                  />
                </div>
                <span className="text-white/80 text-xs md:text-sm ml-4 font-medium tracking-wide">
                  Trusted by 50,000+ shoppers
                </span>
              </div>

              <div>
                <p className="text-white/70 text-sm md:text-base tracking-widest uppercase mb-3 font-label">
                  PandabuySpreadsheet Hub
                </p>
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading text-white leading-tight">
                  The #1 Curated<br />
                  <span className="font-light font-sans text-3xl md:text-5xl lg:text-6xl">
                    Pandabuy Spreadsheet Hub
                  </span>
                </h1>
              </div>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-950 rounded-full font-medium text-sm hover:bg-white/90 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  Buy It Now
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 border border-white/50 text-white rounded-full font-medium text-sm hover:bg-white/15 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  Pandabuy Sheet
                  <i className="ri-external-link-line"></i>
                </a>
              </div>
            </div>

            <div className="flex-1 hidden lg:block">
              <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-md ml-auto font-light">
                Discover updated Pandabuy spreadsheets for sneakers, streetwear, tech &amp; luxury finds — organized, verified, and SEO-ranked daily. Your gateway to smarter Pandabuy shopping.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}